import '../../modules/mode-components';
import '../validators/hal-text-validator';

import * as angular from 'angular';

import CreateDefinitionPaywallModalController from './create-definition-paywall-modal-controller';
import paywallTemplate from './create-definition-paywall.html';
import { DatasourceFacade } from '@mode/accounts/domain';

const createDefinitionDirective = function (
  Modal,
  LibraryDefinitionModel,
  datasourceFacade: DatasourceFacade,
  AlertService
) {
  return {
    restrict: 'A',
    scope: {
      owner: '<',
      account: '<',
      name: '@?',
      modalConfirm: '&',
    },
    link: function ($scope: any, elem, attrs) {
      function saveDefinition(definition) {
        definition.source = 'SELECT 1'; // this should be removed once validation loosens up
        definition.name = $scope.current.name;
        definition.description = $scope.current.description;

        return LibraryDefinitionModel.create({
          params: definition.toParams(),
          account: $scope.owner.username,
        });
      }

      elem.on('click.context', (event) => {
        $scope.current = {};

        if (!$scope.owner.user && $scope.owner.isAtDefinitionLimit()) {
          const modal = Modal.open(
            {},
            {
              controller: CreateDefinitionPaywallModalController,
              controllerAs: 'ctrl',
              template: paywallTemplate,
            }
          );

          modal.result.then((contact) => $scope.modalConfirm({ showContact: contact }));
        } else {
          datasourceFacade.loadDatasources();
          const modal = Modal.open(
            {
              account: $scope.owner,
              current: $scope.current,
            },
            {
              template: `<create-definition-modal
                account="account"
                current="current"
                on-confirm="$close($definition)"
                on-cancel="$dismiss()"
              ></create-definition-modal>`,
              animation: true,
              backdrop: 'static',
            }
          );

          modal.result
            .then(saveDefinition)
            .then((def) => $scope.modalConfirm({ $definition: def }))
            .catch((err) => {
              AlertService.error('Error creating definition');
              console.error(err);
            });
        }
      });

      // cleanup handlers
      $scope.$on('$destroy', () => elem.off('click.context'));
    },
  };
};

createDefinitionDirective.$inject = ['ModalService', 'LibraryDefinitionModel', 'DatasourceFacade', 'ToastService'];

angular.module('mode.components').directive('createDefinition', createDefinitionDirective);
